export const getDefaultCountry = () => {
    return "NORGE";
};
